import customTheme from '@/constants/theme.custom';
import { Box } from '@cmpsr/components';
import React from 'react';

interface LogoIconProps {
  color?: string;
  width?: string | number | { base: string | number; lg: string | number };
  height?: string | number | { base: string | number; lg: string | number };
  alt?: string;
}

const LogoIcon: React.FC<LogoIconProps> = ({
  color = customTheme.colors.darkBlue,
  width = 154,
  height = 154,
  alt = 'Catch logo icon',
}) => {
  return (
    <Box width={width} height={height}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 154 154"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label={alt}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M117.421 72.9579C137.512 72.9579 153.8 56.6704 153.8 36.5789C153.8 16.4874 137.512 0.199951 117.421 0.199951C97.3296 0.199951 81.0421 16.4874 81.0421 36.5789V72.9579H117.421ZM62.0356 30.408C53.9151 30.408 45.8743 32.0073 38.3718 35.1149C30.8697 38.2225 24.0531 42.7772 18.3111 48.5192C12.5692 54.2612 8.01434 61.0776 4.90677 68.5798C1.8348 75.9963 0.236796 83.9389 0.200581 91.9644H0.199951L0.200109 92.104L0.199951 92.2435H0.200581C0.236798 100.269 1.8349 108.212 4.90687 115.628C8.01448 123.13 12.5692 129.947 18.3112 135.689C24.0532 141.431 30.8696 145.986 38.3718 149.093C45.8743 152.201 53.915 153.8 62.0355 153.8C70.1556 153.8 78.1967 152.201 85.6985 149.093C93.201 145.986 100.018 141.431 105.76 135.689C111.503 129.947 116.057 123.13 119.165 115.628C122.272 108.126 123.87 100.085 123.87 91.9644H62.0355L62.0356 30.408Z"
          fill={color}
        />
      </svg>
    </Box>
  );
};

export default LogoIcon;
